import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "title"
}

import { Icon } from '@components';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalOverlay',
  props: {
    isOpen: { type: Boolean },
    showCloseBtn: { type: Boolean },
    title: {},
    borderBottom: { type: Boolean },
    closeCallback: { type: Function }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass({ borderBottom: _ctx.borderBottom })
          }, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            (_ctx.showCloseBtn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "closeBtn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
                }, [
                  _createVNode(_unref(Icon), {
                    "icon-name": "close",
                    lg: ""
                  })
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})